import { render } from "./DisciplinesView.vue?vue&type=template&id=233611e0&scoped=true"
import script from "./DisciplinesView.vue?vue&type=script&lang=js"
export * from "./DisciplinesView.vue?vue&type=script&lang=js"

import "./DisciplinesView.vue?vue&type=style&index=0&id=233611e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233611e0"]])

export default __exports__